import { ScavengerHunt } from "./ScavengerHunts";
import Hugo from "../img/2025/Hugo.jpeg";
import Group from "../img/2025/group.jpeg";
import HS from "../img/Hugo_old.jpg";

export const WintiGayesHalloween2025: ScavengerHunt = {
  title: "Hugos Rache – Die Rückkehr der Affenbande",
  huntingText: (
    <>
      <h1>Hugos Rache – Die Rückkehr der Affenbande</h1>
      <p>
        Letztes Jahr habt ihr Hugos Schatz gefunden. Ihr habt ihn bloßgestellt,
        besiegt und ihm die letzte Banane genommen. Doch Hugo hat nicht
        vergessen… und schon gar nicht vergeben.
      </p>

      <img src={HS} />
      <p>
        In den Schatten des Estrichs, tief im Keller und zwischen den Wänden hat
        er gewartet – und nun hat er seine alte Affenbande wieder
        zusammengerufen: Mugo der Kleine, Sugo der Sossige, Fugo der Feurige,
        Frugo der Fruchtige, Ruso der Russische, Jugo der Talahon und Huso der
        HS. Nur einer fehlt: Cargo – der Rennfahrer – ist in den Ferien.
      </p>
      <p>
        Gemeinsam haben die sieben übrigen Affen einen teuflischen Plan
        geschmiedet: Sie wollen Hugos neuen Schatz so sichern, dass niemand ihn
        je wieder finden Kann.
      </p>

      <img src={Group} />
      <p>
        Doch ihr wurdet gewarnt. Es gibt noch eine Chance, den Plan zu stoppen.
        Jeder Affe trägt ein Stück des großen Rätsels in sich – aber sie
        sprechen nur in Logik, Symbolen und Rätseln.
      </p>
      <p>
        Wenn ihr alle sieben überlistet, könnt ihr die Bande ein für alle Mal
        auflösen. Wenn nicht…
      </p>

      <p>
        <b>
          Dann gehört der Schatz – und vielleicht auch euer Verstand – für immer
          Hugo.
        </b>
      </p>
      <hr />
      <p>
        <b>Eure Mission:</b>
        <ul>
          <li>Findet die sieben Affen. </li>
          <li>Löst ihre Rätsel. </li>
          <li>Vereitelt Hugos Rache.</li>
        </ul>
      </p>
      <p>
        So könnt ihr die bösen Affen aufhalten:
        <ul>
          <li>Jeder Affe bewacht ein Rätsel. </li>
          <li>
            Löse die sieben Rätsel nacheinander und sammle die Lösungen
            (Ziffern) und nutze sie, um Hugos letzten Plan zu stoppen.
          </li>
          <li>Jedes Rätsel ergibt genau eine Ziffer (0–9). </li>
          <li>
            Merkt euch die Ziffern in der Reihenfolge der Affen: <br />
            <b>Mugo → Sugo → Fugo → Frugo → Ruso → Jugo → Huso.</b>
          </li>
          <li>
            Wenn ihr alle Ziffern habt, bringt sie an der letzten Stelle
            zusammen, um den Schatz zu öffnen. Viel Glück – und passt auf eure
            Köpfe auf.
          </li>
          <li>
            Mugo hat sich im Netz vom Kronleuchter verfangen. Starte dort.
          </li>
        </ul>
      </p>
    </>
  ),
  solutionCode: "9523358",
  congratsText: (
    <>
      <h2>🎃 Geschafft! 🎃</h2>
      <img src={Hugo} />
      <p>
        Was?! Ihr habt Mugo, Sugo, Fugo, Frugo, Ruso, Jugo und sogar Huso (Cargo
        hat ja Ferien) geschlagen?! Pah! Ich hätte wissen müssen, dass ich mich
        nicht auf diese Chaoten verlassen kann! Na schön… ihr habt gewonnen. Der
        Schatz gehört euch. Aber wehe, ihr klaut wieder meine Bananen – das gibt
        Krieg! <br />
        <br />
        <b>🍌🐵 Hol dir aus Hugos Kessel den Preis ab!</b>
      </p>
    </>
  ),
};
